import {
  Box,
  Container,
  Divider,
  Grid,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Popover,
  Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {
  Cancel,
  CheckCircle,
  Close,
  MapOutlined,
  Visibility,
} from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import BottomDrawer from "./BottomDrawer";
import clsx from "clsx";
import { alpha } from "@mui/material/styles";
import RepairRequestInfoModal from "./RepairRequestInfoModal";
import { apps, userAccountTypeConstants } from "../../../_constants";
import Hidden from "../../../components/Hidden";
import SurveyRepairRequests from "./SurveyRepairRequests";

 function MeldingenTable({
  canDeleteRR,
  showActionColumn,
  isSecondSignature,
  setOpenRepairRequestMap,
  selectedInspection,
  bottomDrawer,
  bottomDrawerClose,
  loading,
  title,
  keyPath,
  buttonText,
  inspection,
  selectedApp,
  assignmentDetail,
  wbObjectId,
  gridDataTitle,
  data,
  ...props
}) {
  const history = useHistory();
  const { t } = useTranslation();
  const [requests, setRequests] = useState([]);
  const classes = useStyles();
  const [openTooltip, setOpenTooltip] = useState({ element: null, image: "" });
  const { user } = useSelector((state) => state.authentication);
  const { drawingFiles } = useSelector((state) => state.dossier);
  const { selected } = useSelector((state) => state.buildings);
  const app = useSelector((state) => state.app);
  const { isCompleteRRLoading, isUpdateReworkLoading, deleteRRLoading } =
    useSelector((state) => state.surveying);  
  const [isOpenInfoModal, setIsOpenInfoModal] = useState(false);
  const [infoType, setInfoType] = useState(null);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  
  const handleCloseMenu = () => {
    setSelectedRequest(null);
    setAnchorEl(null);
  };


  useEffect(() => {
    if (data)
      setRequests(
        data.map((request) => {
          if (request.sync) {
            request.textResolvers = [];
            if (request.resolvers && request.resolvers.length)
              request.textResolvers = request.resolvers.map((x) => x.name).join(', ');
          }
          return {
            ...request,
            id: request.requestId 
          };
        })
      );
  }, [data, isCompleteRRLoading, isUpdateReworkLoading, deleteRRLoading]);

  const handleTooltipClose = (event) => {
    event.stopPropagation();
    setOpenTooltip({ element: null, image: null });
  };

  const infoModalTogglerHandler = (type) => {
    !isOpenInfoModal && setAnchorEl(null);
    setInfoType(isOpenInfoModal ? null : type);
    setIsOpenInfoModal((p) => !p);
  };

  const listToMapRedirectHandler = () => {
    history.push({
      pathname:
        user.type !== userAccountTypeConstants.buyer && app !== apps.aftercare
          ? `/werk/${selected.projectNo}/${
              app === 3 ? "kwaliteitsborging/meldingen/map" : "meldingen/map"
            }`
          : `/meldingen/map`,
      state: {
        selectedRequest: null,
        buildingId: selectedInspection && selectedInspection.buildingId,
        requests: requests,
      },
    });
  };

  const canShowMapIcon =
    requests && requests.length && requests.some((p) => p.drawingPinLocation);

    
  return (<>
    <Hidden smUp>
      <BottomDrawer
        open={bottomDrawer.open && bottomDrawer.key === "gebrekenlijst"}
        close={bottomDrawerClose}
      >
        <div>
          {title && (
            <Grid className={classes.stickyHeader} size={{xs:12}}>
              <div className={classes.drawerHeader}>
                <Typography
                  className={clsx(
                    classes.surveyMomentCardTitle,
                    classes.headerIconContainer
                  )}
                >
                  {t(`${title}`)}
                  {!!canShowMapIcon &&
                    drawingFiles &&
                    !!drawingFiles.length && (
                      <IconButton
                        color="primary"
                        aria-label="upload picture"
                        component="span"
                        onClick={() => listToMapRedirectHandler()}
                        size="large"
                      >
                        <MapOutlined className={classes.mapIcon} />
                      </IconButton>
                    )}
                </Typography>
                <div>
                  <Close
                    className={classes.drawerIcon}
                    onClick={bottomDrawerClose}
                  />
                </div>
              </div>
              <Divider />
            </Grid>
          )}

           <SurveyRepairRequests
            requests={requests}
            inspection={inspection}
            showActionColumn={showActionColumn}
            selectedInspection={selectedInspection}
            isSecondSignature={isSecondSignature}
            loading={loading}
            setOpenRepairRequestMap={setOpenRepairRequestMap}

           />
        </div>
      </BottomDrawer>
    </Hidden>
    <Hidden smDown>
      <Container maxWidth={false} className={classes.mainContainer}>
            <Box p={1} display={'flex'} alignItems={'center'} >
              <Typography variant="h6" >{t(title)}</Typography>
              {
              !!canShowMapIcon &&
             drawingFiles &&
              !!drawingFiles.length && (
                  <IconButton
                   color="primary"
                    aria-label="upload picture"
                    component="span"
                   onClick={() => listToMapRedirectHandler()}
                  >
                    <MapOutlined className={classes.mapIcon} />
                  </IconButton>
                )}
            </Box>
           <SurveyRepairRequests
            requests={requests}
            inspection={inspection}
            showActionColumn={showActionColumn}
            selectedInspection={selectedInspection}
            isSecondSignature={isSecondSignature}
            loading={loading}
            setOpenRepairRequestMap={setOpenRepairRequestMap}

           />
      </Container>
    </Hidden>
    <Popover
      open={openTooltip.element && openTooltip.image}
      anchorEl={openTooltip.element}
      onClose={handleTooltipClose}
      disableRestoreFocus
      anchorOrigin={{
        vertical: "center",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "center",
        horizontal: "left",
      }}
    >
      <div className={classes.tooltipImageContainer}>
        <img src={openTooltip.image} alt="" />
      </div>
    </Popover>
    {isOpenInfoModal && (
      <RepairRequestInfoModal
        selectedRequest={selectedRequest}
        handleClose={infoModalTogglerHandler}
        open={isOpenInfoModal}
        infoType={infoType}
      />
    )}
    {selectedRequest && (
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleCloseMenu}
      >
        <MenuItem
          onClick={() =>
            infoModalTogglerHandler(
              selectedRequest.isRework ? "rework" : "reject"
            )
          }
        >
          <ListItemIcon style={{ minWidth: "40px" }}>
            {!selectedRequest.isRework ? (
              <Cancel color="error" size="small" />
            ) : (
              <Visibility color="primary" size="small" />
            )}
          </ListItemIcon>
          <Typography>
            {t(
              selectedRequest.isRework
                ? t("repairRequest.viewRepairRequestRework")
                : t("general.button.reject")
            )}
          </Typography>
        </MenuItem>
        <MenuItem onClick={() => infoModalTogglerHandler("approve")}>
          <ListItemIcon style={{ minWidth: "40px" }}>
            <CheckCircle size="small" className={classes.colorSuccess} />
          </ListItemIcon>
          <Typography>{t("general.approve")}</Typography>
        </MenuItem>
      </Menu>
    )}
  </>);
}

export default MeldingenTable

const useStyles = makeStyles((theme) => ({
  "@global": {
    ".MuiButtonBase-root:focus": {
      outline: 0,
    },
  },
  customCheckbox: {
    [theme.breakpoints.down("md")]: {
      "& .MuiSvgIcon-root": {
        height: 14,
      },
    },
  },
  drawerHeader: {
    display: "flex",
    padding: theme.spacing(1),
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: 7,
  },
   mainContainer: {
        height: "100%",
        padding: 0,
        backgroundColor:'white'
    },
  surveyMomentCardTitle: {
    [theme.breakpoints.only("xs")]: {
      fontSize: 14,
    },
    [theme.breakpoints.only("sm")]: {
      fontSize: 16,
    },
    fontSize: 12,
    fontWeight: "bold",
    color: theme.palette.common.black,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  drawerIcon: {
    fill: theme.palette.grey[300],
    cursor: "pointer",
  },
  stickyHeader: {
    position: "sticky",
    top: 0,
    background: theme.palette.common.white,
    zIndex: 101,
  },
  meldingenTableButton: {
    color: theme.palette.grey[700],
    "& svg": {
      [theme.breakpoints.down("sm")]: {
        fontSize: "16px !important",
      },
    },
    "& .MuiButton-label": {
      fontSize: 16,
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px !important",
        lineHeight: "0px !important",
      },
    },
    "& .MuiButton-label > .MuiButton-startIcon": {
      [theme.breakpoints.down("sm")]: {
        marginRight: "4px !important",
      },
    },
  },
  meldingenTableDeleteButton: {
    marginRight: 10,
  },
  customMainHeader: {
    fontSize: 14,
    [theme.breakpoints.only("xs")]: {
      fontSize: 14,
    },
    [theme.breakpoints.only("sm")]: {
      fontSize: 16,
    },
    "& .MuiButtonBase-root": {
      [theme.breakpoints.only("xs")]: {
        fontSize: 14,
      },
      [theme.breakpoints.only("sm")]: {
        fontSize: 16,
      },
      fontSize: 14,
      padding: 0,
      margin: 0,
      whiteSpace: "nowrap ",
    },
  },
  papers: {
    minWidth: 100,
    flexGrow: 1,
    padding: theme.spacing(1),
    backgroundColor: theme.palette.common.white,
    borderRadius: 0,
    boxShadow: "none",
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(0, 1),
    },
    [theme.breakpoints.up("sm")]: {
      borderRight: `1px solid ${theme.palette.grey[300]}`,
      "&:nth-last-child(1)": {
        borderRight: `none`,
      },
    },
  },
  paperSubContainer: {
    display: "flex",
    justifyContent: "space-between",
    minHeight: 22,
  },
  cardTitle: {
    fontSize: 12,
    [theme.breakpoints.only("xs")]: {
      fontSize: 14,
    },
    [theme.breakpoints.only("sm")]: {
      fontSize: 16,
    },
    color: theme.palette.grey[500],
    whiteSpace: "wrap",
  },
  removePadding: {
    padding: `${theme.spacing(0)} !important`,
  },
  expandableRow: {
    background: theme.palette.common.white,
    boxShadow: "0.6px 1px 3px #ccc",
    display: "table-row",
    position: "relative",
    top: 0,
    borderRadius: 4,
    "& .MuiTableCell-root": {
      "&:first-child": {
        borderBottomLeftRadius: 4,
      },
      "&:last-child": {
        borderBottomRightRadius: 4,
      },
    },
  },
  wrapMomentTitle: {
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineClamp: 1,
    wordBreak: "break-all" /* number of lines to show */,
    display: "-webkit-box",
    boxOrient: "vertical",
  },
  wrapMomentContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  minCellWidth: {
    minWidth: 100,
  },
  customCell: {
    position: "relative",
  },
  dataTable: {
    paddingBottom: theme.spacing(1),
  },
  mapIcon: {
    fill: theme.palette.primary.main,
    fontSize: 18,
  },

  headerIconContainer: {
    display: "flex",
    alignItems: "center",
  },
  tooltipImageContainer: {
    padding: theme.spacing(1.25),
    "& > img": {
      maxWidth: "200px",
      maxHeight: "200px",
    },
  },
  colorSuccess: {
    padding: theme.spacing(0.2),
    color: theme.palette.success.main,
  },
  success: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: `${alpha(theme.palette.success.main, 0.7)} !important`,
    },
  },
  moreButton: {
    padding: theme.spacing(0.2),
  },
}));
